import _MessageBox2 from "element-ui/lib/theme-chalk/message-box.css";
import "element-ui/lib/theme-chalk/base.css";
import _MessageBox from "element-ui/lib/message-box";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getWhiteListIPs, modifyWhiteListIP } from '@/api/trustDecision';
export default {
  name: 'TrustDecision',
  data: function data() {
    var _this = this;
    // IP 验证函数
    var validateIP = function validateIP(rule, value, callback) {
      if (!value) {
        callback(new Error(_this.$t('trustDecision.ipRequired')));
      } else {
        // IPv4 验证
        var ipv4Pattern = /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/;
        // IPv6 验证 (简化版)
        var ipv6Pattern = /^((([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4})|(([0-9a-fA-F]{1,4}:){1,7}:)|(([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4})|(([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2})|(([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3})|(([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4})|(([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5})|([0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6}))|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/;
        if (ipv4Pattern.test(value) || ipv6Pattern.test(value)) {
          callback();
        } else {
          callback(new Error(_this.$t('trustDecision.invalidIP')));
        }
      }
    };
    return {
      loading: false,
      tableData: [],
      addDialogVisible: false,
      addLoading: false,
      formRef: null,
      addForm: {
        ip: ''
      },
      rules: {
        ip: [{
          required: true,
          validator: validateIP,
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getTableData();
  },
  methods: {
    getTableData: function getTableData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.loading = true;
              _context.prev = 1;
              _context.next = 2;
              return getWhiteListIPs();
            case 2:
              res = _context.sent;
              if (res.code === 0) {
                // 转换为对象数组格式
                _this2.tableData = (res.data.ips || []).map(function (ip) {
                  return {
                    ip: ip
                  };
                });
              } else {
                _Message.error(res.msg || _this2.$t('general.getDataFailed'));
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              _Message.error(_this2.$t('general.getDataFailed'));
            case 4:
              _context.prev = 4;
              _this2.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }))();
    },
    openAddDialog: function openAddDialog() {
      var _this3 = this;
      this.addForm.ip = '';
      this.addDialogVisible = true;
      // 重置表单验证
      this.$nextTick(function () {
        if (_this3.$refs.formRef) {
          _this3.$refs.formRef.clearValidate();
        }
      });
    },
    closeDialog: function closeDialog() {
      this.addForm.ip = '';
    },
    handleAdd: function handleAdd() {
      var _this4 = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var res, _t2;
          return regeneratorRuntime.wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!valid) {
                  _context2.next = 5;
                  break;
                }
                _this4.addLoading = true;
                _context2.prev = 1;
                _context2.next = 2;
                return modifyWhiteListIP({
                  action: 'add',
                  ip: _this4.addForm.ip
                });
              case 2:
                res = _context2.sent;
                if (res.code === 0) {
                  _Message.success(_this4.$t('general.addSuccess'));
                  _this4.addDialogVisible = false;
                  _this4.getTableData();
                } else {
                  _Message.error(res.msg || _this4.$t('general.addFailed'));
                }
                _context2.next = 4;
                break;
              case 3:
                _context2.prev = 3;
                _t2 = _context2["catch"](1);
                _Message.error(_this4.$t('general.addFailed'));
              case 4:
                _context2.prev = 4;
                _this4.addLoading = false;
                return _context2.finish(4);
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[1, 3, 4, 5]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleDelete: function handleDelete(row) {
      var _this5 = this;
      _MessageBox.confirm(this.$t('trustDecision.confirmDelete'), this.$t('general.tip'), {
        confirmButtonText: this.$t('general.confirm'),
        cancelButtonText: this.$t('general.cancel'),
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return modifyWhiteListIP({
                action: 'delete',
                ip: row.ip
              });
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                _Message.success(_this5.$t('general.deleteSuccess'));
                _this5.getTableData();
              } else {
                _Message.error(res.msg || _this5.$t('general.deleteFailed'));
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              _Message.error(_this5.$t('general.deleteFailed'));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 2]]);
      }))).catch(function () {
        // 用户取消删除
      });
    }
  }
};